import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export interface CustomShippingState {
    receiverContactName: string;
    receiverContactPhone: string;
    receiverContactPhoneValid: boolean;
    receiverContactNameValid: boolean;
}

const initialState: CustomShippingState = {
    receiverContactName: "",
    receiverContactPhone: "",
    receiverContactPhoneValid: false,
    receiverContactNameValid: false,
};

const reducer = {
    "ShippingPage/CustomFields/receiverConatactName": (draft: Draft<CustomShippingState>, action: { result: any }) => {
        draft.receiverContactName = action.result;
    },
    "ShippingPage/CustomFields/receiverContactPhone": (draft: Draft<CustomShippingState>, action: { result: any }) => {
        draft.receiverContactPhone = action.result;
    },
    "ShippingPage/CustomFields/receiverContactPhoneValid": (
        draft: Draft<CustomShippingState>,
        action: { result: any },
    ) => {
        draft.receiverContactPhoneValid = action.result;
    },
    "ShippingPage/CustomFields/receiverContactNameValid": (
        draft: Draft<CustomShippingState>,
        action: { result: any },
    ) => {
        draft.receiverContactNameValid = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
